<template>
  <v-card
    class="text-left d-flex flex-column justify-start py-2"
    :class="isMobile ? 'full-width mb-3' : 'mb-10'"
    :style="{ 'min-height': '100%' }"
  >
    <!-- Navigation Buttons -->
    <div v-for="(item, index) in navigationItems" :key="item.key">
      <Button
        v-if="hasPermission(item.permission)"
        color="white"
        class="d-flex justify-space-between full-width view-button black--text"
        :class="isActive(item.key) ? 'highlighted-button' : ''"
        @click="handleNavigation(item.key)"
      >
        {{ item.label }}
        <v-icon large color="grey">mdi-chevron-right</v-icon>
      </Button>
      <v-divider
        v-if="hasPermission(item.permission)"
        class="mx-1"
        :class="index === navigationItems.length - 1 ? 'mb-6' : ''"
      />
    </div>

    <!-- Other Actions Section -->
    <div v-if="hasOtherActions" class="px-3">
      <Typography variant="h-6" class="mt-4 pl-1">Other actions</Typography>

      <div v-for="action in otherActions" :key="action.key">
        <Button
          v-if="hasPermission(action.permission)"
          :text="true"
          color="primary"
          class="d-flex justify-start action-button"
          @click="handleAction(action.key)"
        >
          {{ action.label }}
        </Button>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

import Button from "@/components/generic/Button.vue";
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "AdminNavigationSidebar",
  components: {
    Button,
    Typography,
  },
  props: {
    currentView: {
      type: [String, Number], // This is just used as a key, so it can be a string or a number
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    navigationItems: {
      type: Array,
      default: () => [],
    },
    otherActions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(["permissions"]),
    hasOtherActions() {
      return this.otherActions.some((action) => this.hasPermission(action.permission));
    },
  },
  methods: {
    hasPermission(permission) {
      return this.permissions.includes(permission);
    },

    isActive(key) {
      return this.currentView === key;
    },

    handleNavigation(key) {
      this.$emit("navigation-change", key);
    },

    handleAction(key) {
      this.$emit("action-click", key);
    },
  },
};
</script>

<style scoped>
.view-button {
  line-height: 1.5;
  border-radius: 50px;
  height: 40px;
  margin-bottom: 16px;
  margin-top: 10px;
  padding: 0 0 0 16px !important;
}

.highlighted-button {
  background: #eeeeee !important;
}

.view-button >>> .v-btn__content {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  letter-spacing: 0;
  text-transform: none;
  line-height: 1.5;
  font-size: 16px;
}

.action-button {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  letter-spacing: 0;
  text-transform: none;
  line-height: 1.5;
  font-size: 16px;
  margin-left: 10px !important;
}
</style>
